import React, { useContext } from 'react'
import { Upselling } from '../../components/upselling/upselling'
import { track } from '../../ClevertapWrapper'
import { useNavigate } from 'react-router-dom'
import routes from '../../router/routes'
import { clevertapEvents } from '../../labels'
import { FeatureContext } from '../../context/useFeatureFlagContext'
import { useUpselling } from '../../hooks/useUpselling'

export function Impulsa() {
    const upselling = useUpselling()

    const navigate = useNavigate()
    const { features } = useContext(FeatureContext)

    const handlerNavigate = (route: string, _track?: string) => {
        if (_track) {
            track(_track)
        }

        navigate(route)
    }

    const goToDashboard = () => {
        upselling.updateUpselling('reports', true)
        handlerNavigate(`/${routes.urlDashboard}`, clevertapEvents.drawerReport)
    }

    return (
        <Upselling
            active={features.reports}
            // feature={{
            //     image: require('../../assets/images/upselling/analysis.png'),
            //     title: 'Ya puedes acceder al Análisis de tu Negocio',
            //     btn: {
            //         title: 'Ir a tu dashboard',
            //         action: () => goToDashboard(),
            //     },
            // }}
            pending={{
                version: 2,
                headtitle: 'Análisis de tu negocio',
                title: 'Accede a análisis y datos importantes de tu negocio',
                text: 'Activa funciones que llevaran a tu comercio y/o local al siguiente nivel, facilitando su gestión e impulsando tus ventas.',
                optionsText:
                    'Al activar nuestro Plan Estándar o Plan Pro podrás acceder a importantes funciones como:',
                endText:
                    'Infórmate sobre nuestros planes, comisiones y precios. Contáctanos mediante nuestro chat de soporte y da el siguiente paso para hacer crecer tu negocio.',
                list: [
                    [
                        'Inventario de productos',
                        'Control de stock',
                        'Tienda en APP amiPASS',
                        'Tienda Web (e-commerce)',
                        'Promociones',
                    ],
                    [
                        'Liquidación de productos próximos a vencer',
                        'Configuración de delivery propio',
                        'Activación de delivery amiPASS',
                        'Terminal de pago BCI Pago',
                    ],
                ],
                // btn1: {
                //     title: 'Contratar',
                //     action: () => {
                //         navigate('/subscription')
                //     },
                // },
                // btn2: {
                //     title: 'Hablar con Ventas',
                //     action: () => {
                //         navigate('/communication')
                //     },
                // },
                image: require('../../assets/images/upselling/pc.png'),
                // contract: 'contratando este complemento',
            }}
        />
    )
}
